"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SES;
    }
});
const _nodemailer = /*#__PURE__*/ _interop_require_default(require("nodemailer"));
const _clientses = require("@aws-sdk/client-ses");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SES = class SES {
    async init() {
        const ses = new _clientses.SES({
            apiVersion: '2006-03-01',
            region: this.input.region,
            credentials: {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            }
        });
        this.transporter = _nodemailer.default.createTransport({
            SES: {
                ses,
                aws: {
                    SendRawEmailCommand: _clientses.SendRawEmailCommand
                }
            }
        });
    }
    async mailSend(mail) {
        if (this.transporter) {
            this.transporter.sendMail(_extends({}, mail, {
                from: this.input.from
            }), (err, info)=>{
                if (err) {
                    console.log(err);
                } else {
                    console.log('Message sent: ' + info.response);
                }
            });
        }
    }
    async test() {
        try {
            await this.mailSend({
                to: this.input.from,
                subject: 'Test email',
                html: 'Test email'
            });
            return true;
        } catch (e) {
            _ncError.NcError.pluginTestError(e == null ? void 0 : e.message);
        }
    }
    constructor(input){
        this.input = input;
    }
};
